import {
  React,
  Component,
  withCookies,
  withRouter,
  axios,
  routes
} from 'imports/CommonImports';

import {
  TextField,
  RaisedButton,
  Snackbar
} from 'material-ui';

import {
  LoadingDialog,
  AlertDialog
} from 'imports/DesignImports';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '16em',
  },
  button: {
    width: '16em',
  },
}
class Profile extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      open: false,
      message: "",
      new_password:"",
      confirm_new_password:"",
      token: this.props.apiToken,
      loadingDialog: false,
      alertDialog: false,
    };
  }

  render() {
    return (
      <div style={styles.container}>
        <h2>Perfil de usuario</h2>
        <h3>Cambiar contraseña</h3>
          <TextField
            name = "new_password"
            hintText="Nueva contraseña"
            floatingLabelText="Nueva contraseña"
            type="password"
            errorText={this.getPasswordError()}
            value ={this.state.new_password}
            onChange={this.handleChange}
            inputStyle={styles.input}
          />
          <TextField
            name = "confirm_new_password"
            hintText="Confirma la contraseña"
            floatingLabelText="Confirma la contraseña"
            type="password"
            errorText={this.getConfirmError()}
            value ={this.state.confirm_new_password}
            onChange={this.handleChange}
            inputStyle={styles.input}
          />
          { this.state.loadingDialog ? <LoadingDialog message="Estamos enviando los datos, espera un momento" /> : null }
          { this.state.alertDialog ?
            <AlertDialog
              title='¡Contraseña actualizada!'
              message="Has cambiado tu contraseña"
              acceptLabel='Aceptar'
              cancelLabel=''
              confirm={this.goToHome}
              cancel={this.goToHome}/> :
              null }
        <RaisedButton primary={true} label="Cambiar Contraseña" onClick={this.handleSubmit} buttonStyle={styles.button} style={{marginTop: '1em'}}/>
        <Snackbar open={this.state.open} message={this.state.message} autoHideDuration={4000} onRequestClose={this.handleRequestClose} />
      </div>
    );
  }

  goToHome = () => {
    this.setState({alertDialog: false});
    this.props.history.push('/')
  }

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  handleSubmit(event) {
    if(this.getPasswordError() === '' && this.getConfirmError() === '' && this.notEmpty()){
      this.setState({loadingDialog: true})
      var data = {new_password:this.state.new_password, token: this.state.token}
      var connection = axios.create({
        baseURL: routes.host,
      });
      connection.post(routes.resetPassword, data)
      .then((response) => {
        this.setState({
          loadingDialog: false,
          alertDialog: true,
        });

      })
      .catch((error) => {
        console.log(error);
        this.setState({
          open: true,
          message: "Hubo un error al cambiar tu contraseña.",
          loadingDialog: false,
        });
      });
    }
    else {
      this.setState({
        open: true,
        message: "Los campos no pueden estar vacíos",
      });
    }
  }

  notEmpty = () => {
    if(this.state.new_password !== '' && this.state.confirm_new_password !== ''){
      return true;
    }
    return false;
  }

  getPasswordError = () => {
    if(this.state.new_password.length < 8 && this.state.new_password.length > 0)
      return "La contraseña debe tener al menos 8 caractéres";
    return "";
  }

  getConfirmError = () => {
    if(this.state.new_password !== this.state.confirm_new_password && this.state.confirm_new_password.length > 0)
      return "Las contraseñas deben ser iguales";
    return "";
  }
}

export default withRouter(withCookies(Profile));



// WEBPACK FOOTER //
// ./src/components/common/ResetPassword.js